import { useEffect, useState } from 'react';

import { isPreviewPass } from 'helpers/PlayerHelper';
import { getMVPDFromCookie } from 'helpers/ContentHelper';

export default function useMvpdAuth({ mvpdProviders, isAuthenticated }) {
  const [providerSet, setProviderSet] = useState(false);

  useEffect(() => {
    const didFetchProviders = mvpdProviders && !providerSet;
    const didAuthenticate = isAuthenticated;
    if (didFetchProviders || didAuthenticate) {
      checkMVPD();
    }
  }, [mvpdProviders, isAuthenticated]);

  const checkMVPD = () => {
    if (providerSet) return;

    const mvpd = getMVPDFromCookie();
    if (mvpd && !isPreviewPass(mvpd)) {
      setProviderSet(true);
    } else {
      setProviderSet(false);
    }
  };

  return {
    providerSet,
    setProviderSet,
  };
}
